module.exports = __webpack_public_path__ + "img/cheatsheet-star.a322385e.svg";